module.exports = __webpack_public_path__ + "static/o-t-02-5575cce07aa2d4042728a6ad8c5ebdba.jpg";